module.exports = __webpack_public_path__ + "img/Lesson-tw.1ef56bd0.png";